/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_header_index11 = /** @type {(inputs: {}) => string} */ () => {
	return `Library`
};

const fr_header_index11 = /** @type {(inputs: {}) => string} */ () => {
	return `Bibliothèque`
};

const de_header_index11 = /** @type {(inputs: {}) => string} */ () => {
	return `Bibliothek`
};

const es_header_index11 = /** @type {(inputs: {}) => string} */ () => {
	return `Biblioteca`
};

const it_header_index11 = /** @type {(inputs: {}) => string} */ () => {
	return `Biblioteca`
};

const ar_header_index11 = /** @type {(inputs: {}) => string} */ () => {
	return `مكتبة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const header_index11 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.header_index11(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("header_index11", locale)
	if (locale === "en") return en_header_index11(inputs)
	if (locale === "fr") return fr_header_index11(inputs)
	if (locale === "de") return de_header_index11(inputs)
	if (locale === "es") return es_header_index11(inputs)
	if (locale === "it") return it_header_index11(inputs)
	return ar_header_index11(inputs)
};
export { header_index11 as "HEADER_INDEX" }